



















































































import BaseLogin from '@/components/login/base-login-page.vue';
import * as service from '@/services/auth';
import { clearLocalStorage, clearSessionStorage } from '@/services/session-data';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import BaseAccess from './base-access.vue';

@Component({
  components:{
    BaseLogin
  }
})
export default class FirstAccess extends BaseAccess {
  userName = null;
  showTerms = false;
  termsAccepted = false;
  pathTerms = null;

  public form: any = {
    valid: false,
    rules: {
      termsAccepted: [
        (v) => !!v || 'Para prosseguir, leia os termos de uso e clique em "Li e concordo"'
      ],     
      code: [
        (v) => !!v || 'Informe o código recebido por SMS'
      ],
      password: [
        (v) => !!v || 'Digite a Nova Senha',
        (v) =>
          (!!v && /\d/g.test(v)) || 'A senha precisa ter pelo menos um numero',
        (v) =>
          (!!v && /[A-Z]/g.test(v)) ||
          'A senha precisa ter pelo menos um caractere maiúsculo',
        (v) =>
          (!!v && /[a-z]/g.test(v)) ||
          'A senha precisa ter pelo menos um caractere minúsculo',
        (v) =>
          (!!v && /[^\w\d]/g.test(v)) ||
          'A senha precisa ter pelo menos um caractere especial',
        (v) =>
          (!!v && v.length > 5) || 'A senha precisa ter no mínimo 6 caracteres',
      ],
    },
  };

  private uuid:string;  

  public mounted(): void {
    clearLocalStorage();
    clearSessionStorage();
    this.uuid = this.$route.query.uuid ? this.$route.query.uuid.toString() : null;    
    if (!this.uuid) {
      this.showInvalidLink();
    } else {
      this.esqueciSenhaIniciar();
    }
  }

  public esqueciSenhaIniciar(): void{
    this.msg = null;
    this.msgErro = null;
    this.loader.start('Processando...');

    service.forgotPasswordUuidInit(this.uuid).subscribe(res => {
      this.esqueciSenhaIniciarResult = res;
      this.userName = res.nome;
      this.showTerms = res.showTermosUso;
      this.pathTerms = res.termosUsoUrl;
      this.msg = res.msg;
      this.step = this.STEP_CONFIRM_SMS_CODE;
      this.loader.stop();
      setTimeout(() => {
        this.$refs['user.validationCode'].focus();        
      }, 200);
    }, (error) => {
      this.msgErro = error.data.message;
      this.loader.stop();
    });
  }

  private showInvalidLink(): void {
    const action = () => {
      this.$router.push('/login');
    };
    this.dialog.show(
      'error',
      'Link inválido',
      'Link inválido ou expirado, você será redirecionado para a tela de login.',
      'Ok',
      action,
      '',
      null,
    );
  }

  isTermsOk() {
    return !this.showTerms || this.step != this.STEP_CONFIRM_SMS_CODE || this.termsAccepted;
  }

  @Watch('termsAccepted')
  onTermsAccepted() {
    if(this.termsAccepted) {
      setTimeout(() => {
        this.$refs['user.validationCode'].focus();        
      }, 100);
    }
  }
  
}
